module.exports = __webpack_public_path__ + "img/2011.06acdb4b.jpg";